import React, { FC } from 'react';
import { SearchBar } from '../../search/components/search-bar/SearchBar';
import { HeaderContent } from '../HeaderContent';
import styles from './search_header.module.scss';
import { Navigation } from '../../navigation/Navigation';
import { HeaderContentLogo } from '../HeaderContentLogo';
import { useUser } from '../../user/useUser';
import { Row, Column } from '../../components/grid/Grid';

type Props = {
  subHeader?: React.ReactNode;
};

export const SearchHeader: FC<Props> = ({ subHeader }) => {
  const { loggedIn } = useUser();

  return (
    <header id="nav" className={styles.container}>
      <HeaderContent>
        <Row>
          <Column>
            <div className={styles.subContainer}>
              <HeaderContentLogo
                loggedIn={loggedIn}
                hideLogoTitle
                source="nav"
              />
              <div className={styles.searchContainer}>
                <SearchBar />
              </div>
              <div className={styles.navContainer}>
                <Navigation />
              </div>
            </div>
          </Column>
        </Row>
        {subHeader}
      </HeaderContent>
    </header>
  );
};
